import { useContext, useEffect, useState } from 'react';

import { AnalyticsEventNames } from '~/constants/AnalyticsEventMap';
import { DepositContext } from '~/context/Deposit/DepositContext';
import { useTracking } from '~/hooks/tracking/useTracking';
import { ModalMultiStepProps } from '~/models/deposits/ModalMultiStepProps';
import { Button } from '~/vinovest-design-system/components';

export const ConfirmAcknowledgements = ({ setStep }: ModalMultiStepProps) => {
    const { destinationPortfolio } = useContext(DepositContext);

    const { captureEvent } = useTracking();
    const [isChecked, setIsChecked] = useState<boolean>(false);

    const initiateTracking = () => {
        captureEvent(AnalyticsEventNames.DepositAcknowledgementStart, {
            type: destinationPortfolio === 'wine' ? 'wine' : 'whiskey'
        });
    };

    useEffect(() => {
        initiateTracking();
    }, []);

    const handleConfirmSubmit = async (): Promise<void> => {
        if (isChecked) {
            captureEvent(AnalyticsEventNames.DepositAcknowledgementConfirmed, {
                type: destinationPortfolio === 'wine' ? 'wine' : 'whiskey'
            });
            setStep(1);
        }
    };

    return (
        <div>
            <div className={'mb-4 text-[12px]'}>
                <p>By proceeding I understand that:</p>
                <ul className={'list-disc max-w-[400px]'}>
                    <li className={'ml-[20px] mb-[10px]'}>Wine and whiskey are long-term assets.</li>
                    <li className={'ml-[20px] mb-[10px]'}>
                        I expect to hold wine for 5 to 10+ years, and selling before 5 years may incur a penalty.
                    </li>
                    <li className={'ml-[20px] mb-[10px]'}>
                        American whiskey casks require a 3-year minimum hold, and Scotch whisky casks require a 5-year
                        minimum hold. I will be unable to sell my cask(s) before this timeframe.
                    </li>
                    <li className={'ml-[20px] mb-[10px]'}>
                        Buying and selling wine and whiskey is a multi step process and may take time. Vinovest cannot
                        guarantee that purchases or sales will be immediate or close within a set timeframe.
                    </li>
                </ul>
                <div className={'flex'}>
                    <input
                        type={'checkbox'}
                        checked={isChecked}
                        onClick={(e) => setIsChecked(e.currentTarget.checked)}
                    />{' '}
                    <p className={'text-platinum-800 text-12 ml-2 uppercase'}>I understand</p>
                </div>
            </div>

            <div className={'flex flex-col'}>
                <Button
                    variant={'green'}
                    type={'submit'}
                    classnames={'mb-5'}
                    disabled={!isChecked}
                    onClick={handleConfirmSubmit}
                >
                    Submit Transfer
                </Button>
                <Button variant={'secondary'} onClick={() => setStep(0)}>
                    Back
                </Button>
            </div>
        </div>
    );
};
